import { Link } from 'react-router-dom';

export default function CtaDonation() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Hyperrealistic park as background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=hyperrealistic%20photograph%20of%20a%20beautiful%20urban%20park%20in%20Bucaramanga%20Colombia%20with%20plastic%20wood%20benches%20pedestrian%20paths%20pergolas%20water%20fountains%20surrounded%20by%20tropical%20trees%20lush%20green%20vegetation%20community%20gathering%20golden%20hour%20warm%20light%20very%20detailed%20photorealistic%20render&width=1920&height=900&seq=ctabg001&orientation=landscape"
          alt="Parque urbano construido con madera plástica reciclada - Fundación Frais Santander"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/70 to-black/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 md:px-14 py-28 md:py-36 max-w-4xl mx-auto">

        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-8">
          <div className="w-8 h-px bg-[#ef9a9a]/60"></div>
          <span
            className="text-[#ef9a9a] text-[10px] tracking-[0.5em] uppercase font-semibold"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Esta foto es de hoy. Actúa ahora.
          </span>
          <div className="w-8 h-px bg-[#ef9a9a]/60"></div>
        </div>

        <h2
          className="text-white font-bold leading-tight mb-6"
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(2.4rem, 5vw, 4.8rem)',
          }}
        >
          El futuro de nuestros hijos<br />
          <span style={{ color: '#a5d6a7' }}>depende de lo que hagamos hoy.</span>
        </h2>

        <p
          className="text-white/65 text-base md:text-lg leading-relaxed mb-4 max-w-2xl mx-auto"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          La basura que ves atrás es real. Está en municipios de Santander ahora mismo. 
          Tu apoyo permite que la Fundación Frais intervenga más zonas, rescate más espacios y 
          forme más comunidades.
        </p>
        <p
          className="text-white/40 text-sm mb-12 italic"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          ¿Cuántas generaciones más van a crecer viendo esto como normal?
        </p>

        {/* Dual CTA */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-14">
          <Link
            to="/donar"
            className="group flex items-center gap-3 px-10 py-4 bg-[#43a047] text-white font-bold text-sm tracking-widest uppercase rounded-full hover:bg-[#388e3c] transition-all duration-300 cursor-pointer whitespace-nowrap hover:scale-105"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <i className="ri-heart-fill group-hover:scale-125 transition-transform duration-300"></i>
            Quiero donar
          </Link>
          <Link
            to="/contacto"
            className="flex items-center gap-3 px-10 py-4 border-2 border-white/30 text-white/80 font-bold text-sm tracking-widest uppercase rounded-full hover:border-white hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Vincular mi institución
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Trust row */}
        <div className="flex flex-col sm:flex-row items-center gap-6 pt-8 border-t border-white/10 w-full justify-center">
          {[
            { icon: 'ri-shield-check-line', text: 'Donación 100% segura', color: '#a5d6a7' },
            { icon: 'ri-file-text-line', text: 'Certificado de donación', color: '#a5d6a7' },
            { icon: 'ri-map-pin-2-line', text: '87 municipios de Santander', color: '#a5d6a7' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <i className={`${item.icon}`} style={{ color: item.color }}></i>
              <span className="text-white/55 text-xs" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
